"use client";

import { type RefObject, useEffect, useRef } from "react";
import { scrollContainerToItem } from "../scrolling";

const useInitialScroll = (
  scrollRef: RefObject<HTMLDivElement | null>,
  getOrderedItems: () => HTMLDivElement[],
  initialScrollToIndex?: number,
) => {
  const hasApplied = useRef(false);

  useEffect(() => {
    if (hasApplied.current) {
      return;
    }
    hasApplied.current = true;
    if (initialScrollToIndex === undefined) {
      return;
    }
    const target = getOrderedItems()[initialScrollToIndex];
    if (target) {
      scrollContainerToItem(target, scrollRef.current);
    }
  }, [scrollRef, initialScrollToIndex, getOrderedItems]);
};

export default useInitialScroll;
